import React from 'react'
import { joinClassNames } from '../../utilities'
import css from './Submit.module.css'

export const Submit = ({ className, text, title }) => {
  const classes = joinClassNames(css.printReview, css.Submit, className)
  const heading = title || 'Now submit your complaint'
  const txt =
    text ||
    'By submitting this complaint you are confirming that the details you are providing are true.'

  return (
    <div className={classes}>
      <h2>{heading}</h2>
      <div className="ds-text--lead">{txt}</div>
    </div>
  )
}
